import { useQueryStateContext } from '../contexts';
import { isCatalogESIndex } from '../utils';

export const useCatalogName = (): string => {
  const state = useQueryStateContext();
  return isCatalogESIndex(state) && state?.catalogName ? state.catalogName : '';
};
